module.exports = __webpack_public_path__ + "Spanish 2027 HSA User Guide.pdf";